import { isAdmin } from '../../utils/roles';

// Bottom tab bar (mobile). 'new' is the centre action button, not a route.
export const TABS = [
  { to: '/dashboard', label: 'Home', icon: 'home' },
  { to: '/sales', label: 'Sales', icon: 'receipt' },
  { key: 'new', label: 'New sale', icon: 'plus' },
  { to: '/invoices', label: 'Invoices', icon: 'doc' },
  { key: 'more', label: 'More', icon: 'menu' },
];

// Everything else: the More sheet (mobile) and the More dropdown (desktop).
export const moreLinks = (user) => [
  { to: '/customers', label: 'Customers', icon: 'users' },
  { to: '/analytics', label: 'Analytics', icon: 'chart' },
  { to: '/products', label: 'Products', icon: 'box' },
  { to: '/inventory', label: 'Inventory', icon: 'stack' },
  ...(isAdmin(user) ? [{ to: '/users', label: 'Users', icon: 'shield' }] : []),
  { to: '/profile', label: 'Profile', icon: 'user' },
];

// Desktop primary links.
export const DESKTOP_PRIMARY = [
  { to: '/dashboard', label: 'Dashboard' },
  { to: '/sales', label: 'Sales' },
  { to: '/customers', label: 'Customers' },
  { to: '/invoices', label: 'Invoices' },
];

export const NEW_SALE_PATH = '/dashboard?new=sale';
